import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { useWeb3React } from '@web3-react/core';

const useTotalSpoolTvr = () => {
    const { interfaceSDK } = useContext(appContext);

    const { chainId } = useWeb3React();

    const { data, error } = useSWR(interfaceSDK ? [chainId, 'totalSpoolTvr'] : null, () =>
        interfaceSDK!.get.getTotalSpoolsTvr()
    );

    return {
        totalSpoolTvr: data,
        isLoading: !error && !data,
        error,
    };
};

export default useTotalSpoolTvr;
